<template>
  <section class="services" id="services">
    <div class="container">
      <!-- Title  -->
      <h1 class="title">I Nostri Servizi</h1>

      <!-- Services List  -->
      <ul class="services-list row row-cols-1 row-cols-lg-2">
        <!-- Single Service  -->
        <li
          class="service col mb-5 mb-lg-max position-relative"
          v-for="(service, i) in services"
          :key="i"
        >
          <!-- Service title  -->
          <span class="service-title">
            <i class="fa-solid" :class="service.icon"></i>
            <h4 class="subtitle">{{ service.name }}</h4>
          </span>

          <!-- Descrption  -->
          <p class="service-description paragraph">{{ service.description }}</p>

          <!-- Image -->
          <div class="service-image d-none d-lg-block">
            <img
              :src="
                require(`../assets/images/${service.name.toLowerCase()}.jpg`)
              "
              :alt="`${service.name.toLowerCase()}-image`"
            />
          </div>
        </li>
      </ul>

      <!-- Contact us  -->
      <div @click="scrollView('contact-us')" class="contact-us ms_btn-primary">
        Contattaci
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Services",
  data: function () {
    return {
      services: [
        {
          name: "Assistenza",
          icon: "fa-wrench",
          description:
            "Effettuiamo riparazioni per tutti i marchi trattati nelle nostre zone di competenza specifiche per ogni marchio.",
        },
        {
          name: "Sanificazione",
          icon: "fa-spray-can-sparkles",
          description:
            "Provvederemo a sanificare ed igienizzare la macchina interna smontandola e pulendola approfonditamente",
        },
        {
          name: "Installazione",
          icon: "fa-fan",
          description:
            "Effettuiamo installazioni su impianti predisposti e non, solitamente si effettua un sopralluogo per verificare che ci siano tutti i presupposti per una corretta installazione",
        },
        {
          name: "Manutenzione",
          icon: "fa-screwdriver-wrench",
          description:
            "Effettuiamo manutenzioni che comprendono: sanificazione,pulizia e controllo del funzionamento per prevenire possibili problemi di funzionamento e guasti futuri",
        },
      ],
    };
  },
  methods: {
    scrollView: function (pushTo) {
      document.getElementById(`${pushTo}`).scrollIntoView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.services {
  background-color: $back_color;

  .container {
    // Title
    .title {
      @media screen and (min-width: 992px) {
        margin-bottom: 5rem;
      }
    }
    // Services List
    .services-list {
      padding: 0 0.625rem;
      justify-content: center;

      // Single Service
      .service {
        text-align: center;

        // Title
        .subtitle {
          padding-left: 0.625em;

          @media screen and (min-width: 992px) {
            margin-bottom: 2.5rem;
          }
        }

        // Description
        .paragraph {
          @media screen and (min-width: 992px) {
            margin-bottom: 2.5rem;
          }
        }

        // Icon
        i {
          position: relative;
          top: -2px;
          color: $brand_primary_color;
        }
      }
    }

    // Contact us
    .contact-us {
      margin-top: 1.25rem;
    }
  }
}
</style>
